import { useInfiniteQuery, useQueryClient } from '@tanstack/react-query'
import {
  getWorkReview,
  GetWorkerEvaluationsParams,
} from 'api/review/getWorkReview'
import { useCompanyInfo } from 'queries/company'
import { workReviewKey, workReviewRootKey } from './keys'

type UseWorkReviewFilters = Omit<GetWorkerEvaluationsParams, 'cursor'>

export function useWorkReviewQuery(filters: UseWorkReviewFilters) {
  const { data: company } = useCompanyInfo()

  return useInfiniteQuery({
    queryKey: workReviewKey(filters),
    queryFn: ({ pageParam, signal }) => {
      if (!company?.id) {
        return Promise.reject(new Error('Company not loaded'))
      }

      return getWorkReview(
        company.id,
        {
          ...filters,
          cursor: pageParam,
        },
        signal
      )
    },
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
    enabled: Boolean(company?.id),
  })
}

export function useInvalidateWorkReview() {
  const queryClient = useQueryClient()

  return {
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: workReviewRootKey,
      }),
  }
}
